/**
 * Responsive body sizes. Do not use Tailwind `text-sm` here: it is always
 * `0.875rem` (~14px) at every breakpoint unless you add responsive overrides.
 *
 * `lg:` is 1025px+ in this repo (`packages/ui/tailwind.config.ts`), matching auth-shell desktop.
 */
export const responsiveBodySmClassName = "text-[12px] leading-4 lg:text-[14px] lg:leading-5";
/**
 * Shared message row for ErrorBanner / SuccessBanner (Poppins + tracking + flex).
 */
export const bannerMessageTextClassName = [
    "font-poppins font-normal tracking-[0.25px] flex-1 m-0 p-0",
    responsiveBodySmClassName,
].join(" ");
//# sourceMappingURL=typography-responsive.js.map